import React, { useEffect, useState } from "react";
import Chart from "./Chart";
import InputYeilds from "./InputYeilds";
import TotalizerValues from "./TotalizerValues";
import AggregatedEfficiency from "./AggregatedEfficiency";
import HomeAlerts from "./HomeAlerts";
import AdditionalParameters from "./AdditionalParameters";
import refresh from "../../Assets/img/refresh.png";
import ProductionCounterComp from "./ProductionCounterComp";
import "./Homepage.css";
import { Col, Row, Progress, DatePicker, Space, Spin } from "antd";
import { HiOutlineRefresh, FiAlertOctagon } from "../../Utils/imports";
import {
  chartTabs,
  dashboardTabs,
  productionCounter,
  selectOptions,
} from "../../Utils/constants";
import { HomeVar } from "../../Utils/variables";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import HeaderSelects from "../../Components/Header/HeaderSelects";
import { useDispatch, useSelector } from "react-redux";
import { getAlerts, getMergeFullDay, getMergeList, getMergeShiftWise, onShiftDateChange, updateChartData } from "../../API-Interaction/apiServices/kpis.api";
import { onDropDownChange } from "../../API-Interaction/apiServices/plants.api";
import { antIcon, disabledDate, generateRoomId, getFromLocalStorage, setToLocalStorage } from "../../Helpers/helpers";
import moment from "moment";
import ChartTabs from "../../Components/ChartTabs/ChartTabs";
import LineEfficiency from "../../Components/KPIS/LineEfficiency";
import NoDataFound from "../../Components/Helpers/NoDataFound";
import { getRolesList } from "../../API-Interaction/apiServices/roles.api";
import socketIoClient, { io } from 'socket.io-client'
import { socketsURL } from "../../Environments/environment";
import { disconnect, socket } from "../../Libraries/socket";
import { updateStatTime } from "../../Redux/features/kpis.slice";



dayjs.extend(customParseFormat);


const {
  last_updated,
  time,
  line_efficiency,
  production_counter,
  efficiency_chart,
} = HomeVar;

function Homepage() {

  const { current } = useSelector(state => state?.plant)
  const { pageLoaders, componentLoaders: { chart = false } } = useSelector(state => state?.utils.loaders)
  const { stats } = useSelector(state => state.kpis)
  const kpis = useSelector(state => state.kpis)
  let selector = useSelector(state => state?.plant?.current)
  const dispatch = useDispatch()

  const apiToHit = {
    1: async () => getMergeShiftWise(dispatch, current),
    2: async () => getMergeFullDay(dispatch, current)
  }

  // DASHBOARD TABS

  const [dashTab, setDashTab] = useState(1);

  // client-side sockets

  const fetchCharts = () => {
    let currentLocal = getFromLocalStorage('current')
    socket.on(`${currentLocal?.line?.id}-stats`,
      (lineStats) => {
        // console.log("Socket: ", lineStats)
        let data = getFromLocalStorage('stats')
        if (Object.keys(data)?.length && lineStats?.oee?.length && lineStats?.machine !== "def_wil12") {
          // console.log("Update")
          updateChartData(lineStats, dispatch, kpis, data)
        }
      })
  }


  useEffect(() => {
    current?.plant && apiToHit[dashTab]()
    getRolesList(dispatch, selector)
    current?.plant && socket.emit('join', `${current?.line?.id}-stats`);
    fetchCharts()
    return () => { disconnect() }
  }, [current, dashTab])

  const ShowTabs = dashboardTabs.map((tabs) => (
    <div key={tabs.id}>
      <span
        className={dashTab === tabs.id ? "dashTabsActivated" : "dashTabs"}
        onClick={() => setDashTab(tabs.id)}
      >
        {tabs.name}
      </span>
    </div>
  ));



  const RefreshButton = () => {
    return (
      <div className="dflex alignCenter gap10 justifySB p10 boxBg boxBorder boxBorderRad refreshButton">
        <HiOutlineRefresh style={{
          background: "#c2c9d8",
          color: "white",
          padding: '2px',
          borderRadius: "100%",
          fontSize: "15px"

        }} />
        <p>
          {last_updated} <strong>{moment(stats?.updated_at).format('hh:mm a')}</strong>
        </p>
      </div>
    );
  };

  // DATE RANGE PICKER



  return (
    <Spin indicator={antIcon} spinning={pageLoaders?.dashboard}>
      {

        Object.keys(stats)?.length ? <>
          <Row className="pl20 pr20">
            <Col lg={18} md={24} xs={24} className="dflex flexColumn gap20" >
              <div
                className="dflex alignCenter gap20"
                style={{
                  padding: "20px 0",
                }}
              >
                {ShowTabs}
              </div>
              <Row className="dflex" style={{ gap: "14px" }}>
                <Col span={6} lg={6} md={24} xs={24} className="HomePage_ProgressBar">
                  <LineEfficiency />
                </Col>
                <Col span={17} lg={17} md={24} className="HomePage_Cards">
                  <Row>
                    <Col span={24}>
                      <h3 className="cardHead">{production_counter}</h3>
                    </Col>
                  </Row>
                  <Row className="HomePageCards_Row">
                    <ProductionCounterComp stats={stats} />
                  </Row>
                </Col>
              </Row>
              <Row className="chart_cont">
                <Col span={24} className="HomePage_Chart">
                  <Row className="Homepage_chart_container">
                    <Col span={14}>
                      <h3 className="cardHead">{efficiency_chart}</h3>
                    </Col>
                    <Col span={10} className="Homepage_chart_filter">
                      {/* <Space direction="vertical">
                        <DatePicker
                          // defaultValue={current?.shiftDate || moment(new Date())}
                          value={moment(current?.shiftDate) || moment(new Date())}
                          format="YYYY-MM-DD"
                          disabledDate={disabledDate}
                          onChange={(date, dateString) => onShiftDateChange(date, dateString, dispatch)}
                          className="eff_datepicker"
                        />
                      </Space> */}
                      {dashTab == 1 &&
                        <HeaderSelects
                          selectData={{
                            options: current?.line?.shifts,
                            value: current?.shift?.range,
                            valueLabel: 'name',
                            idLabel: 'range',
                            onChange: onDropDownChange,
                          }}
                        />
                      }
                    </Col>
                  </Row>
                  <Spin indicator={antIcon} spinning={chart}>
                    <Row>
                      <Col span={6} className="EFF_Chart_tabs">
                        <ChartTabs />
                      </Col>
                      <Col span={18}>
                        <Chart data={stats?.oee} />
                      </Col>
                    </Row>
                  </Spin>
                </Col>
              </Row>
            </Col>
            <Col span={6} lg={6} md={24} xs={24}>
              <div
                style={{
                  padding: "15px 0 33px 0",
                  display: "flex",
                  alignItems: "flex-end",
                  gap: "10px",
                  justifyContent: "flex-end",
                  flexDirection: 'column'
                }}
              >
                {RefreshButton()}
              </div>
              <HomeAlerts />
            </Col>
          </Row>
          <Row className="Homepage_R2">
            <Col lg={18} md={24}>
              <Row
                className="dflex gap10 justifySB HomePage_R2_boxes"
                style={{ margin: "0 17px 0 0" }}
              >
                <Col lg={7} md={24}>
                  <InputYeilds />
                </Col>
                <Col lg={7} md={24}>
                  <TotalizerValues />
                </Col>
                <Col lg={7} md={24}>
                  <AggregatedEfficiency />
                </Col>
              </Row>
            </Col>
            <Col lg={6} md={24} className="mt10R">
              <AdditionalParameters />
            </Col>
          </Row>
        </> :
          <NoDataFound />
      }
    </Spin>
  );
}

export default Homepage;
